export const UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_REQUEST = 'UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_REQUEST';

export const updateProcessStatementCommentVisibilityRequest = ({ modules }) => ({
    type: UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_REQUEST,
    payload: { modules  }
});
